import React from 'react';
import { type SVGComponentProps } from '../../../../types/Svgs';

const SVGComponent: React.FC<SVGComponentProps> = ({ primaryColor, secondaryColor, size }) => {
  return (
    <div>
      <svg
        width={size != null ? size[0].toString() : '39'}
        height={size != null ? size[1].toString() : '39'}
        viewBox="0 0 39 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <style>
          {`
          .primaryBus { fill: ${primaryColor != null ? primaryColor : '#D89C29'} }
          .secondaryBus { fill: ${secondaryColor != null ? secondaryColor : 'grey'} }
        `}
        </style>
        <circle cx="19.3604" cy="19.3516" r="18.1865" className="primaryBus" stroke="white" strokeWidth="1.5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2502 10.0527H25.4707C26.961 10.0527 28.1533 11.245 28.1533 12.7353V25.4774C28.1533 26.0735 27.9297 26.6697 27.5571 27.1913V28.5326C27.5571 29.1287 27.11 29.5758 26.5139 29.5758H24.353C23.8314 29.5758 23.3843 29.1287 23.3843 28.5326V28.16H15.3366V28.5326C15.3366 29.1287 14.8895 29.5758 14.3679 29.5758H12.207C11.6108 29.5758 11.1638 29.1287 11.1638 28.5326V27.1913C10.7912 26.6697 10.5676 26.0735 10.5676 25.4774V12.7353C10.5676 11.245 11.7599 10.0527 13.2502 10.0527ZM15.4111 26.2971C12.0579 26.3716 11.2383 25.85 11.3128 22.6458C12.2815 24.2852 13.6228 25.4774 15.4111 26.2971ZM23.3098 26.2971C26.663 26.3716 27.4826 25.85 27.4081 22.6458C26.4394 24.2852 25.0981 25.4774 23.3098 26.2971ZM13.9953 11.7666H24.7256C26.1413 11.7666 27.4081 12.9588 27.4081 14.4491V19.7397C27.4081 21.23 26.1413 22.4223 24.7256 22.4223H13.9953C12.5795 22.4223 11.3128 21.23 11.3128 19.7397V14.4491C11.3128 12.9588 12.5795 11.7666 13.9953 11.7666Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.40672 13.6299H9.44994C9.82252 13.6299 10.1206 14.0025 10.1206 14.375V17.8773C10.1206 18.2498 9.82252 18.6224 9.44994 18.6224H8.40672C8.03415 18.6224 7.73608 18.2498 7.73608 17.8773V14.375C7.73608 14.0025 8.03415 13.6299 8.40672 13.6299Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.3142 13.6299H29.271C28.8984 13.6299 28.6003 14.0025 28.6003 14.375V17.8773C28.6003 18.2498 28.8984 18.6224 29.271 18.6224H30.3142C30.6868 18.6224 30.9848 18.2498 30.9848 17.8773V14.375C30.9848 14.0025 30.6868 13.6299 30.3142 13.6299Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default SVGComponent;
